import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingHeaderComponentData extends ConvertedComponentData {
  trainingId?: string;
}

export const TRAINING_HEADER_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingHeaderComponentData>[]>('TrainingHeaderConverter')

